import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogDetailModule } from '../change-log-detail/change-log-detail.module';
import { ChangeLogPipesModule } from '../../pipes/change-log-pipes.module';
import { ChangeLogDetailByTypeModule } from '../change-log-detail-by-type/change-log-detail-by-type.module';
import { AttendeeChairmanExtensionLogDetailsComponent } from './attendee-chairman-extension-log-details.component';
import { ChangeLogGuestConfigurationModule } from './guest-configuration/change-log-guest-configuration.module';
import {
  AttendeeExcursionsLogDetailsModule
} from 'ag-common-svc/lib/components/changes-history-grid/components/excursions-log-details/attendee-excursions-log-details.module';

@NgModule({
  declarations: [AttendeeChairmanExtensionLogDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    ChangeLogDetailModule,
    ChangeLogPipesModule,
    ChangeLogDetailByTypeModule,
    ChangeLogGuestConfigurationModule,
    AttendeeExcursionsLogDetailsModule,
  ],
  exports: [AttendeeChairmanExtensionLogDetailsComponent],
})
export class AttendeeChairmanExtensionLogDetailsModule {}
